import { Component, OnInit, ViewChild } from '@angular/core';
import { LoadingController, ModalController } from '@ionic/angular';
import { Header } from 'src/app/interfaces/book.interface';
import { AquabotService } from 'src/app/services/aquabot.service';
import { AuthService } from 'src/app/services/auth.service';
import { RedatwaterService } from 'src/app/services/redatwater.service';
import { ToastService } from 'src/app/services/toast.service';
import { IonicSelectableComponent } from 'ionic-selectable';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-app-registro',
  templateUrl: './app-registro.component.html',
  styleUrls: ['./app-registro.component.scss'],
})
export class AppRegistroComponent implements OnInit {

  tipoCuenta: string = 'persona';
  tipoDocumento: string;
  numeroDocumento: string;
  correoElectronico: string;
  aceptaTerminos: boolean = false;
  nombre: string;
  apellidos: string;
  sexo: string;
  numeroContacto: number;
  //fechaNacimiento: string;
  ubicacionCiudad: string;
  direccion: string;
  tarjeta_clave: number;
  tarjeta_clave_rep: number;

  viewBtnContinuar = false;

  // Estado inicial: sin selección
  tipoIdentificacion: string | null = null;

  // Texto dinámico para mostrar la selección
  textoIdentificacion: string = 'No se ha seleccionado ninguna opción.';

  ciudades: any[]; // Asegúrate de cargar las ciudades en esta variable
  @ViewChild('seleccionarComponent') seleccionarComponent: IonicSelectableComponent;

  header: Header = {
    nivel: 2,
    pagina: '',
    titulo: '',
  };

  channelSistema: any = null;
  channelApp: any = null;

  idiomaSeleccionado: string = null;
  selectedLanguage: string;
  itemsIdiomaApp: any = [];
  itemsIdioma: any = [];
  idiomaPagina = 'APP_REGISTRO_CUENTA';
  authDispositivo: any = null;

  aquaBot: any = {
    guia_referencia: '',
    msg: '',
    estado: ''
  };

  verificarClave = '';

  constructor(
    private auth: AuthService,
    private redatwater: RedatwaterService,
    private modalController: ModalController,
    private aquabot: AquabotService,
    private vetanaAlerta: AlertService,
    private toast: ToastService,
    private loadingCtrl: LoadingController

  ) {
    // Inicializa las variables según tus necesidades
    console.log('App: Registro App.');
    this.header.pagina = '/';
    this.header.titulo = 'CREAR CUENTA';
  }

  ngOnInit() {
    this.auth.getAuthDispositivoObservable().subscribe(async (getDispositivo: any) => {
      console.log('Dispositivo Auth ->', getDispositivo);
      if (getDispositivo) {
        this.listaCiudades();
        //console.log('Parametros de idioma App -> ', this.itemsIdiomaApp);
        //console.log('Parametros de idioma -> ', this.itemsIdioma);
        //console.log('Test 1 -> ', this.itemsIdiomaApp.app_loading);
        this.authDispositivo = getDispositivo;
        this.redatwater.getDataSistema(this.authDispositivo.sistema_id).then((getData: any) => {
          console.log('Seguimiento -> Datos de sistema: ', getData);
          if (getData) {
            if (getData?.channel_app[0].channel_sistema) {
              this.channelApp = getData.channel_app;
              this.channelSistema = getData?.channel_app[0].channel_sistema;
              this.tipoDocumento = '1';
              this.establecerTipoCuenta();

            } else {
              console.log('Seguimiento de errores -> Datos de sistema:  ', getData);
            }
          } else {
            console.log('Seguimiento de errores -> Datos de sistema:  ', getData);
          }
        }).catch((err: any) => {
          console.log('Seguimiento de errores -> ', err);
        });

      }
    });

  }

  // Método que actualiza el texto dinámico
  actualizarTextoIdentificacion() {
    switch (this.tipoIdentificacion) {
      case 'cajero':
        this.textoIdentificacion = 'Número de Cajero/Sistema: ' + this.channelSistema.public_key;
        break;
      case 'empresa':
        this.textoIdentificacion = 'Número de Empresa: ' + this.channelSistema.empresa_codigo;
        break;
      default:
        this.textoIdentificacion = 'No se ha seleccionado ninguna opción.';
        break;
    }
  }

  ciudadChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {


    if (event?.value) {
      const ciudad = event.value;
      console.log('Ciudad -> ', ciudad);
      this.ubicacionCiudad = ciudad.ciudad_id;
    } else {
      this.resetSeleccionarComponent();
    }

  }

  checkClave() {
    this.verificarClave = '';
    let clave = this.tarjeta_clave;
    let claveRep = this.tarjeta_clave_rep;

    // Verificar que ambas contraseñas estén ingresadas
    if (clave && claveRep) {
      // Verificar si las contraseñas coinciden
      if (clave === claveRep) {
        // Verificar si la contraseña cumple con criterios de seguridad
        if (this.esClaveSegura('' + clave)) {
          this.verificarClave = 'Coincide y es segura';
        } else {
          this.verificarClave = 'Coincide, pero no es segura';
        }
      } else {
        this.verificarClave = 'No coincide';
      }
    } else {
      this.verificarClave = 'Ambas contraseñas son requeridas';
    }
  }

  // Función para verificar si la contraseña es segura
  esClaveSegura(clave: string): boolean {

    // Verificar si la contraseña es común
    const contraseñasComunes = ['1234', '4321', '1111', '2222', '3333', '4444'];
    if (contraseñasComunes.includes(clave)) {
      return false;
    }

    return true; // La contraseña es segura
  }


  async listaCiudades() {
    const loading = await this.loadingCtrl.create({
      message: 'Verificando ciudades...',
      spinner: 'crescent',
      showBackdrop: true
    });
    loading.present();

    this.redatwater.listaCiudades(this.redatwater.getPaisSeleccionado()).then((data: any) => {
      //console.log('Ciudades del Pais -> ' + data);
      this.ciudades = data;
      loading.dismiss();
    });
  }

  async resetSeleccionarComponent() {
    if (this.seleccionarComponent) {
      this.seleccionarComponent.clear(); // Limpia el componente visualmente
    }
    this.ubicacionCiudad = null; // Reinicia el modelo de datos
  }


  terminos() {
    console.log('Ventana -> Terminos ');
    this.terminos_web();
  }

  async terminos_web() {
    console.log('Navegador -> Portal Transaccional: Terminos y condiciones');
    this.aquabot.enlaceSugerido(this.redatwater.getWebUrl(), 'portal transaccional');
  }

  aceptarTerminos() {
    console.log('Aceptar terminos:' + this.aceptaTerminos);

    if (this.aceptaTerminos) {
      //this.toast.msgAppCenter('A través de www.bancodelagua.com encuentra información y acceso de tus productos y servicios.', 'success');
      this.viewBtnContinuar = true;
    } else {
      this.toast.msgAppCenter('Para nosotros es muy importante el derecho a la privacidad.', 'danger');
      this.viewBtnContinuar = false;
    }
  }

  formDatos() {
    // Prepara los datos para enviar por API

    let datosRegistro = {
      tipo_cuenta: this.tipoCuenta,
      tipo_documento_id: this.tipoDocumento,
      numero_documento: this.numeroDocumento,
      email: this.correoElectronico,
      aceptaTerminos: this.aceptaTerminos,
      nombres: this.nombre,
      apellidos: this.apellidos,
      sexo: this.sexo,
      celular: this.numeroDocumento, //this.numeroContacto,
      //fecha_nacimiento: this.fechaNacimiento,
      ciudad: this.ubicacionCiudad,
      direccion: this.direccion,
      tarjeta_clave: this.tarjeta_clave,
      tipo_relacion: this.tipoIdentificacion,
      texto_relacion: this.textoIdentificacion
    };

    console.log('Procesando datos de registro: ' + JSON.stringify(datosRegistro));

    // Extrae las claves del objeto datosRegistro en un arreglo
    let camposRequeridos: string[] = Object.keys(datosRegistro);

    // Utiliza la función some para validar si al menos uno de los campos está vacío
    if (camposRequeridos.some(campo => !datosRegistro[campo])) {

      if (this.tarjeta_clave === this.tarjeta_clave_rep) {


        this.redatwater.getRegistroUsuario(datosRegistro, this.authDispositivo.id).then((getData: any) => {
          console.log('Seguimiento -> ', getData);
          if (getData) {

            if (getData?.registro) {
              console.log('Info registro', getData.registro);
              this.vetanaAlerta.msgAppCenter('AT-WATER', '¡Explora tu saldo! <span class="text-success">Accede desde la app Banco del Agua con los datos en tu correo.</span>');
              this.closeModal();
            } else {
              this.vetanaAlerta.msgAppCenter('AT-WATER', '¡Vaya! Algo salió mal.  <span class="text-success">Por favor, inténtalo de nuevo más tarde.</span>');
            }

          } else {
            console.log('Seguimiento de errores -> ', getData);
          }

        }).catch((error: any) => {
          console.log('Seguimiento de errores -> ', error);
        });


      } else {
        this.vetanaAlerta.msgAppCenter('AT-WATER', '¡Oops! La clave de tarjeta debe coincidir.');
      }

    } else {
      this.vetanaAlerta.msgAppCenter('AT-WATER', '¡Oops! Campos de registros necesarios.');
    }
  }

  establecerTipoCuenta() {
    console.log('Seguimiento -> Tipo de cuenta: ', this.tipoCuenta);
    this.tarjeta_clave = null;
    this.tarjeta_clave_rep = null;

    if (this.tipoCuenta == 'empresa') {
      this.sexo = 'otro';
      this.tipoDocumento = '5';
      this.apellidos = '';
    } else {
      this.sexo = 'otro';
      this.tipoDocumento = '5';
    }
  }

  closeModal() {
    console.log('Cerrar ventana!');
    this.modalController.dismiss({ app: false }).catch((err: any) => {
      console.log('Seguimiento de errores -> ', err);
    });
  }

}
